import request from '../untils/request';

export const communityCommentsApi = params => {
  return request({
    url: '/commont/commont/index',
    authCode: 'COMMONT_INDEX',
    params,
  });
};

export const communityCommentsVideoApi = params => {
  return request({
    url: '/commont/commont/live-index',
    authCode: 'COMMONT_INDEX',
    params,
  });
};

export const communityCommentsVerifyApi = params => {
  return request({
    url: '/commont/commont/verify',
    params,
  });
};

export const communityCommentsDelApi = params => {
  return request({
    url: '/commont/commont/delete',
    params,
  });
};

export const communityCommentsUpdateApi = params => {
  return request({
    url: '/commont/commont/update',
    params,
  });
};

export const communityPostsApi = params => {
  return request({
    url: '/commont/commont-post/index',
    authCode: 'POST_INDEX',
    params,
  });
};

export const communityPostsDetailApi = params => {
  return request({
    url: '/commont/commont-post/detail',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsSaveApi = params => {
  return request({
    url: '/commont/commont-post/save',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsTopApi = params => {
  return request({
    url: '/commont/commont-post/top',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsRecommendApi = params => {
  return request({
    url: '/commont/commont-post/recommend',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsVerifyApi = params => {
  return request({
    url: '/commont/commont-post/verify',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsChangeGoodsIdApi = params => {
  return request({
    url: '/commont/commont-post/change-goods',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsChangeClassApi = params => {
  return request({
    url: '/commont/commont-post/change-class',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsRepostApi = params => {
  return request({
    url: '/commont/commont-post/repost',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsDelApi = params => {
  return request({
    url: '/commont/commont-post/delete',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityPostsSyncApi = params => {
  return request({
    url: '/commont/commont-post/sync-post',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityLevelsApi = params => {
  return request({
    url: '/commont/level/index',
    authCode: 'POST_INDEX',
    params,
  });
};

export const communityLevelUpdateApi = params => {
  return request({
    url: '/commont/level/update',
    params,
  });
};

export const communityUsersApi = params => {
  return request({
    url: '/commont/member/index',
    authCode: 'POST_INDEX',
    params,
  });
};

export const communityScoreLogsApi = params => {
  return request({
    url: '/commont/member/score-logs',
    authCode: 'POST_INDEX',
    params,
  });
};

export const communityTrialListApi = params => {
  return request({
    url: '/commont/member/trial',
    authCode: 'POST_INDEX',
    params,
  });
};

export const communityShowSilenceApi = params => {
  return request({
    url: '/commont/member/show-silence',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityDoSilenceApi = params => {
  return request({
    url: '/commont/member/silence',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityCancelSilenceApi = params => {
  return request({
    url: '/commont/member/cancel-silence',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityLevelListApi = params => {
  return request({
    url: '/commont/member/level-list',
    params,
  });
};

export const communityLevelOptApi = params => {
  return request({
    url: '/commont/member/level-opt',
    params,
  });
};


export const communityAddTrialGoodsApi = params => {
  return request({
    url: '/commont/member/add-trial-goods',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityGetTrialGoodsApi = params => {
  return request({
    url: '/commont/member/get-trials',
    params,
    authCode: 'POST_INDEX',
  });
};

export const communityGetWhiteListApi = params => {
  return request({
    url: '/commont/commont/setting',
    params,
    authCode: 'COMMONT_SETTING',
  });
};

export const communitySetWhiteListApi = params => {
  return request({
    url: '/commont/commont/change-setting',
    params,
    authCode: 'COMMONT_SETTING',
  });
};

export const communityCommentsVideoVerifyApi = params => {
  return request({
    url: '/commont/commont/verify-live',
    params,
  });
};

export const communityUserCommentsEditApi = params => {
  return request({
    url: '/commont/commont-post/edit-user-post',
    params,
  });
};
